(function(){
  function initQuiz(){

  // ===== Données pierres (cœur 13, stock réel Shopify) =====
  // base URL publique = alunara.pl ; handle = bizuteria-z-<pierre>
  var BASE = 'https://alunara.pl';
  var STONES = {
    TYG: { name:'Tygrysie oko', tag:'złoto-brązowa odmiana kwarcu z efektem kociego oka', keys:'Odwaga · Ochrona · Pewność siebie', col:'bizuteria-z-tygrysim-okiem', img:'https://cdn.shopify.com/s/files/1/1016/5177/5823/files/stone-tygrysie-oko.webp?v=1782552858' },
    JAS: { name:'Jaspis czerwony', tag:'„krew matki ziemi"', keys:'Ugruntowanie · Wytrzymałość · Pierwotna energia', col:'bizuteria-z-jaspisem', img:'https://cdn.shopify.com/s/files/1/1016/5177/5823/files/stone-jaspis.webp?v=1782552884' },
    AME: { name:'Ametyst', tag:'fioletowa odmiana kwarcu', keys:'Spokój · Intuicja · Sen', col:'bizuteria-z-ametystem', img:'https://cdn.shopify.com/s/files/1/1016/5177/5823/files/stone-ametyst_7fa0aed0-d090-421e-b269-720769bd6f7b.webp?v=1782552769' },
    ROZ: { name:'Kwarc różowy', tag:'różowa odmiana kwarcu', keys:'Miłość · Czułość · Łagodność do siebie', col:'bizuteria-z-kwarcem-rozowym', img:'https://cdn.shopify.com/s/files/1/1016/5177/5823/files/stone-kwarc-rozowy.webp?v=1782552796' },
    OBS: { name:'Obsydian', tag:'czarne szkło wulkaniczne', keys:'Prawda · Lustro podświadomości · Ochrona psychiczna', col:'bizuteria-z-obsydianem', img:'https://cdn.shopify.com/s/files/1/1016/5177/5823/files/stone-obsydian.webp?v=1782553065' },
    LAP: { name:'Lapis lazuli', tag:'„kamień królów i mędrców"', keys:'Prawda · Mądrość · Komunikacja królewska', col:'bizuteria-z-lapis-lazuli', img:'https://cdn.shopify.com/s/files/1/1016/5177/5823/files/stone-lapis-lazuli.webp?v=1782552923' },
    AGA: { name:'Agat', tag:'pasiasta odmiana chalcedonu', keys:'Równowaga · Ugruntowanie · Stabilność emocjonalna', col:'bizuteria-z-agatu', img:'https://cdn.shopify.com/s/files/1/1016/5177/5823/files/stone-agat.webp?v=1782552872' },
    OPA: { name:'Opal', tag:'„kamień marzycieli"', keys:'Intuicja · Delikatność · Inspiracja', col:'bizuteria-z-opalem', img:'https://cdn.shopify.com/s/files/1/1016/5177/5823/files/stone-opal.webp?v=1782552831' },
    ONY: { name:'Onyks', tag:'czarna lub pasiasta odmiana chalcedonu', keys:'Dyscyplina · Ochrona psychiczna · Wytrwałość', col:'bizuteria-z-onyksem', img:'https://cdn.shopify.com/s/files/1/1016/5177/5823/files/stone-onyks.webp?v=1782553105' },
    MAL: { name:'Malachit', tag:'„kamień transformacji"', keys:'Transformacja głęboka · Uwolnienie · Strażnik', col:'bizuteria-z-malachitem', img:'https://cdn.shopify.com/s/files/1/1016/5177/5823/files/stone-malachit.webp?v=1782552896' },
    SOD: { name:'Sodalit', tag:'„kamień myślicieli"', keys:'Logika · Jasność umysłu · Spokojna komunikacja', col:'bizuteria-z-sodalitem', img:'https://cdn.shopify.com/s/files/1/1016/5177/5823/files/stone-sodalit.webp?v=1782553028' },
    APA: { name:'Apatyt', tag:'„kamień motywacji i celu"', keys:'Motywacja · Jasność celu · Komunikacja', col:'bizuteria-z-apatytem', img:'https://cdn.shopify.com/s/files/1/1016/5177/5823/files/stone-apatyt.webp?v=1782553051' },
    SEL: { name:'Selenit', tag:'kamień księżycowego światła', keys:'Światło · Oczyszczenie · Czysta cisza', col:'bizuteria-z-selenitem', img:'https://cdn.shopify.com/s/files/1/1016/5177/5823/files/stone-selenit.webp?v=1782553091' }
  };
  var ORDER = ['TYG','JAS','AME','ROZ','OBS','LAP','AGA','OPA','ONY','MAL','SOD','APA','SEL'];
  // départage : pierres mieux stockées d'abord (= quizSim.mjs TIEBREAK)
  var TIEBREAK = ['TYG','JAS','AME','ROZ','OBS','LAP','AGA','OPA','ONY','MAL','SOD','APA','SEL'];

  // ===== Questions PL + scoring (libellés PL ; points = transcription EXACTE de quizSim.mjs) =====
  var Q = [
    { label:'Czego w Tobie teraz najmniej?', opts:[
      ['Spokoju i dobrego snu', {AME:3,SEL:1,ROZ:1}],
      ['Miłości i czułości', {ROZ:3,MAL:1}],
      ['Pewności siebie i odwagi', {TYG:3,ONY:1}],
      ['Energii i siły do działania', {JAS:3,APA:1}],
      ['Ochrony i poczucia bezpieczeństwa', {OBS:3,ONY:1}],
      ['Skupienia i nauki', {SOD:3,APA:1}],
      ['Równowagi i wyciszenia', {AGA:3,SEL:1,MAL:1}],
      ['Komunikacji i prawdy', {LAP:3,SOD:1}]
    ]},
    { label:'Który kolor przyciąga Cię dziś najbardziej?', colors:true, opts:[
      ['Fioletowy', {AME:3,SEL:1}, '#7c5fa8'],
      ['Różowy', {ROZ:3,MAL:1}, '#e3a9b5'],
      ['Złoto-brązowy', {TYG:3,JAS:1}, '#b07d39'],
      ['Czerwony', {JAS:3,ONY:1}, '#a8392f'],
      ['Zielony', {MAL:3,AGA:1}, '#4f7d5a'],
      ['Jasny niebieski', {APA:3,SOD:1}, '#8fc0d6'],
      ['Głęboki granat', {LAP:3,SOD:1}, '#2f3f7c'],
      ['Perłowa biel', {SEL:3,OPA:1}, '#f3efe7'],
      ['Czarny', {OBS:3,ONY:1}, '#23201c'],
      ['Mieniący się', {OPA:3,AME:1}, 'linear-gradient(135deg,#e9d5e6,#cfe6e3,#f0e3cf)']
    ]},
    { label:'Dokąd uciekłabyś teraz najchętniej?', opts:[
      ['Cicha leśna polana o świcie', {AGA:2,MAL:1}],
      ['Turkusowa laguna', {APA:2,OPA:1}],
      ['Górski szczyt, czyste powietrze', {TYG:2,JAS:1}],
      ['Rozgwieżdżone nocne niebo', {AME:2,OPA:1}],
      ['Ciepły dom, świece, koc', {ROZ:2,SEL:1}],
      ['Kryształowa grota', {SEL:2,LAP:1}]
    ]},
    { label:'Co najlepiej opisuje ten moment Twojego życia?', opts:[
      ['Nowy początek, świeża karta', {SEL:2,APA:1,AGA:1}],
      ['Gojenie się po czymś trudnym', {MAL:2,ROZ:1}],
      ['Walka, dużo wyzwań naraz', {JAS:2,OBS:1,TYG:1}],
      ['Poszukiwanie, pytania bez odpowiedzi', {SOD:2,OPA:1,AME:1}],
      ['Stabilizacja, chcę to utrzymać', {AGA:2,ONY:2}],
      ['Rozwój, ambicje, wzrost', {APA:2,TYG:1,JAS:1}]
    ]},
    { label:'Jak najchętniej nosiłabyś swój kamień?', opts:[
      ['Bransoletka, codziennie, blisko skóry', {AGA:2,TYG:1,ROZ:1}],
      ['Wisiorek na sercu', {ROZ:1,MAL:2,AME:1}],
      ['Surowy kamień na biurku', {APA:1,OBS:1,SEL:1}],
      ['Kamień pod poduszką, do snu', {AME:2,SEL:1}],
      ['W kieszeni, jako sekretny talizman', {ONY:3,OBS:1}]
    ]},
    { label:'Które słowo brzmi dziś jak obietnica?', opts:[
      ['Spokój', {SEL:2,AME:1,AGA:1}],
      ['Miłość', {ROZ:2,MAL:1}],
      ['Odwaga', {TYG:2,ONY:1}],
      ['Jasność', {LAP:2,APA:1}],
      ['Wolność', {OPA:2,APA:1}],
      ['Ochrona', {OBS:2,ONY:1}],
      ['Równowaga', {AGA:2,MAL:1}],
      ['Prawda', {LAP:2,SOD:1}]
    ]},
    { label:'Który żywioł czujesz w sobie najmocniej?', opts:[
      ['Ziemia', {JAS:2,AGA:1,ONY:1}],
      ['Woda', {ROZ:2,OPA:1,AME:1}],
      ['Ogień', {TYG:2,JAS:1}],
      ['Powietrze', {LAP:2,SOD:1,APA:1}],
      ['Eter / duch', {AME:2,SEL:1,OPA:1}]
    ]},
    { label:'Gdyby kamień mógł szepnąć Ci jedno zdanie, co chciałabyś usłyszeć?', opts:[
      ['Jesteś bezpieczna.', {OBS:2,ONY:1}],
      ['Zasługujesz na miłość.', {ROZ:2,MAL:1}],
      ['Masz w sobie siłę.', {TYG:2,JAS:1}],
      ['Wszystko się ułoży.', {AGA:2,SEL:1}],
      ['Widzisz w sobie jasno.', {SOD:2,LAP:1}],
      ['Zaufaj swojej intuicji.', {OPA:2,AME:1}]
    ]}
  ];

  // ===== Scoring (= winner() de quizSim.mjs) =====
  function winner(scores){
    var best = -1, who = [];
    for (var i=0;i<ORDER.length;i++){
      var k = ORDER[i], s = scores[k] || 0;
      if (s > best){ best = s; who = [k]; }
      else if (s === best){ who.push(k); }
    }
    who.sort(function(a,b){ return TIEBREAK.indexOf(a) - TIEBREAK.indexOf(b); });
    return who[0];
  }

  // ===== State / DOM =====
  var answers = new Array(Q.length).fill(-1);
  var cur = 0;
  var $ = function(id){ return document.getElementById(id); };
  var introEl = $('aluq-intro'), quizEl = $('aluq-quiz'), resultEl = $('aluq-result');
  var qHost = $('aluq-questions'), fill = $('aluq-fill'), step = $('aluq-step'), backBtn = $('aluq-back');

  function renderQuestion(){
    var q = Q[cur];
    var optsClass = q.colors ? 'aluq-opts aluq-opts--colors' : 'aluq-opts';
    var html = '<div class="aluq-q is-active"><h2 class="aluq-q-label">' + q.label + '</h2><div class="' + optsClass + '">';
    for (var o=0;o<q.opts.length;o++){
      var opt = q.opts[o];
      if (q.colors){
        html += '<button type="button" class="aluq-opt aluq-opt--color" data-o="' + o + '"><span class="aluq-swatch" style="background:' + opt[2] + '"></span>' + opt[0] + '</button>';
      } else {
        html += '<button type="button" class="aluq-opt" data-o="' + o + '">' + opt[0] + '</button>';
      }
    }
    html += '</div></div>';
    qHost.innerHTML = html;
    fill.style.width = ((cur) / Q.length * 100) + '%';
    step.textContent = 'Pytanie ' + (cur + 1) + ' / ' + Q.length;
    backBtn.hidden = (cur === 0);
    var btns = qHost.querySelectorAll('.aluq-opt');
    for (var b=0;b<btns.length;b++){
      btns[b].addEventListener('click', function(e){
        var o = parseInt(e.currentTarget.getAttribute('data-o'), 10);
        answers[cur] = o;
        if (cur < Q.length - 1){ cur++; renderQuestion(); }
        else { showResult(); }
      });
    }
  }

  function showResult(code){
    if (!code){
      var sc = {};
      for (var i=0;i<Q.length;i++){
        var pts = Q[i].opts[answers[i]][1];
        for (var k in pts){ if (pts.hasOwnProperty(k)) sc[k] = (sc[k] || 0) + pts[k]; }
      }
      code = winner(sc);
    }
    var s = STONES[code];
    if (!s) return;
    // Persiste le résultat : le form email fait un POST natif /contact → reload
    // avec ?customer_posted=true ; on restaure alors cet écran (voir fin d'initQuiz).
    try { sessionStorage.setItem('aluqStone', code); } catch(e){}
    $('aluq-r-name').textContent = s.name;
    $('aluq-r-tag').textContent = s.tag;
    $('aluq-r-keys').textContent = s.keys;
    var img = $('aluq-r-img'); img.src = s.img; img.alt = s.name;
    $('aluq-r-desc').textContent = 'To kamień, który teraz najlepiej do Ciebie pasuje. Noś go blisko siebie i pozwól mu Ci towarzyszyć.';
    var cta = $('aluq-r-cta');
    cta.href = BASE + '/collections/' + s.col;
    cta.textContent = 'Zobacz biżuterię z: ' + s.name;
    var emailStone = $('aluq-email-stone');
    if (emailStone) emailStone.textContent = s.name;
    fill.style.width = '100%';
    quizEl.hidden = true; introEl.hidden = true;
    resultEl.classList.add('is-active');
    if (window.scrollTo) window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function start(){
    answers = new Array(Q.length).fill(-1);
    cur = 0;
    introEl.hidden = true;
    resultEl.classList.remove('is-active');
    quizEl.hidden = false;
    renderQuestion();
  }
  function restart(){
    try { sessionStorage.removeItem('aluqStone'); } catch(e){}
    resultEl.classList.remove('is-active');
    quizEl.hidden = true;
    introEl.hidden = false;
    if (window.scrollTo) window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  $('aluq-start').addEventListener('click', start);
  $('aluq-restart').addEventListener('click', restart);
  backBtn.addEventListener('click', function(){ if (cur > 0){ cur--; renderQuestion(); } });

  // Capture email : le custom element `newsletter-form` de Minimog n'existe pas
  // (aucun customElements.define dans les assets) → le form fait un POST NATIF vers
  // /contact. Shopify inscrit le client puis redirige ici avec ?customer_posted=true
  // (reload complet). On restaure alors l'écran résultat depuis sessionStorage pour
  // que la visiteuse revoie sa pierre + le message de succès rendu par Liquid.
  var posted = /[?&]customer_posted=true/.test(window.location.search);
  if (posted){
    var savedCode = null;
    try { savedCode = sessionStorage.getItem('aluqStone'); } catch(e){}
    if (savedCode && STONES[savedCode]){
      // Empêche le navigateur de restaurer le scroll d'avant soumission (bas de page)
      // et neutralise l'ancre de redirection Shopify, pour rester en haut du résultat.
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      showResult(savedCode);
      try { history.replaceState(null, '', window.location.pathname); } catch(e){}
      window.scrollTo(0, 0);
      window.addEventListener('load', function(){ window.scrollTo(0, 0); });
    }
  }

  }
  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", initQuiz); } else { initQuiz(); }
})();
